'use client';

/**
 * Boot splash shown while Next.js loads the heavy configurator chunk.
 * Matches LoadingScreen branding so users never see the old circle spinner.
 */
const LOGO_URL = '/uploads/1784387128670_h1da_HParadis_LOGO_Henessy_06.png';

export function BootLoader({
  productName = 'PARADIS UNLIMITED',
  tagline = 'Preparing your experience',
}: {
  productName?: string;
  tagline?: string;
}) {
  const bg = '#fafafa';
  const text = '#18181b';
  const accent = '#18181b';

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{ backgroundColor: bg, color: text }}
      aria-busy
      aria-live="polite"
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: `radial-gradient(ellipse 70% 55% at 50% 42%, ${accent}14 0%, transparent 62%)`,
        }}
      />

      <div className="relative flex flex-col items-center px-6">
        <div className="mb-8 flex h-[72px] w-[72px] items-center justify-center" style={{ perspective: 230 }}>
          <img
            src={LOGO_URL}
            alt=""
            className="max-h-full max-w-full object-contain opacity-95"
            style={{
              transformOrigin: '50% 48%',
              transformStyle: 'preserve-3d',
              animation: 'c3d-boot-spin-y 1.4s linear infinite',
            }}
          />
        </div>

        <h1
          className="mb-2 max-w-md text-center text-[15px] font-medium tracking-[0.18em] uppercase opacity-90"
          style={{ color: text }}
        >
          {productName}
        </h1>

        <p className="mb-10 text-center text-[12px] font-light tracking-[0.12em] opacity-45" style={{ color: text }}>
          {tagline}
        </p>

        <div className="w-40 space-y-2">
          <div className="h-px overflow-hidden rounded-full" style={{ backgroundColor: `${text}18` }}>
            <div
              className="h-full rounded-full"
              style={{
                width: '28%',
                backgroundColor: accent,
                opacity: 0.85,
                animation: 'c3d-boot-progress 1.8s ease-in-out infinite',
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes c3d-boot-spin-y {
          to { transform: rotateY(360deg); }
        }
        @keyframes c3d-boot-progress {
          0% { width: 12%; }
          50% { width: 72%; }
          100% { width: 28%; }
        }
      `}</style>
    </div>
  );
}
